/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Shipping_Carrier_Duplicate_NameInputs */

const vi_toast_shipping_carrier_duplicate_name = /** @type {(inputs: Toast_Shipping_Carrier_Duplicate_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên đơn vị vận chuyển đã tồn tại`)
};

/**

* @param {Toast_Shipping_Carrier_Duplicate_NameInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_shipping_carrier_duplicate_name = /** @type {((inputs?: Toast_Shipping_Carrier_Duplicate_NameInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Shipping_Carrier_Duplicate_NameInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_shipping_carrier_duplicate_name(inputs)
});